class ImageSize {
	constructor(params) {
		this.path = params.path;
		this.parentWidth = params.parentWidth;
		this.optionsMaxWidth = params.optionsMaxWidth;
		this.optionsWidth = params.optionsWidth;
		this.originalWidth = params.originalWidth;
		this.devices = {
			mobile: 480,
			tablet: 960,
			desktop: 1200,
		};

		this.cdnPath = 'https://cdn.orderonline.id/';
		// this.compressPath = 'http://d32xc09eirob59.cloudfront.net/compress';
		this.compressPath = 'https://assets.orderonline.id/compress';
		this.placeHoldPath = 'https://place-hold.it/';
	}

	// get active device
	// eslint-disable-next-line class-methods-use-this
	getDevice() {
		const ua = navigator.userAgent;
		if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
			return 'tablet';
		}
		if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
			return 'mobile';
		}
		return 'desktop';
	}

	// get maz width
	getMaxWidth() {
		const device = this.getDevice();
		const deviceSize = this.devices[device];
		let width = this.parentWidth && this.parentWidth !== 0 ? this.parentWidth : deviceSize;
		// check option max width
		if (this.optionsMaxWidth !== null && this.optionsMaxWidth.value !== '' && this.optionsMaxWidth.unit !== '') {
			// check options width is pixel
			if (this.optionsMaxWidth.unit === 'px' && (this.optionsMaxWidth.value !== 0 || this.optionsMaxWidth.value !== '')) {
				const widthValue = parseInt(this.optionsMaxWidth.value);
				// compare this.optionsMaxWidth with device size
				if (widthValue < deviceSize) {
					// check this.parentwidth not 0 && this.optionsMaxWidth less than parent width
					if (this.parentWidth && this.parentWidth !== 0) {
						if (widthValue < this.parentWidth) {
							width = widthValue;
						} else {
							width = this.parentWidth;
						}
					}
				} else if (this.parentWidth && this.parentWidth !== 0) {
					width = this.parentWidth;
				}

				// width = width / this.optionsMaxWidth.value;
			} else if (this.optionsMaxWidth.unit === '%' && (this.optionsMaxWidth.value !== 0 || this.optionsMaxWidth.value !== '')) {
				width *= (this.optionsMaxWidth.value / 100);
				width = Math.floor(width);
			}
		}

		return width;
	}

	// get width
	getWidth() {
		const device = this.getDevice();
		const deviceSize = this.devices[device];
		let width = this.parentWidth && this.parentWidth !== 0 ? this.parentWidth : deviceSize;
		let widthUnit = '%';
		// width
		if (this.optionsWidth !== null && this.optionsWidth.value !== '' && this.optionsWidth.unit !== '') {
			if (this.optionsWidth.unit === 'px' && this.optionsWidth.value !== 0) {
				const widthValue = parseInt(this.optionsWidth.value);
				// compare this.optionsMaxWidth with device size
				if (widthValue < deviceSize) {
					// check parentwidth not 0 && this.optionsMaxWidth less than parent width
					if (this.parentWidth && this.parentWidth !== 0) {
						if (widthValue < this.parentWidth) {
							width = widthValue;
						} else {
							width = this.parentWidth;
						}
					}
				} else if (this.parentWidth && this.parentWidth !== 0) {
					width = this.parentWidth;
				}

				widthUnit = 'px';
			} else if (this.optionsWidth.unit === '%' && this.optionsWidth.value !== 0) {
				width *= (this.optionsWidth.value / 100);
				width = Math.floor(width);
			} else {
				width = this.parentWidth && this.parentWidth !== 0 ? this.parentWidth : deviceSize;
			}
		}

		return {
			value: width,
			unit: widthUnit,
		};
	}

	getVisualSize() {
		const device = this.getDevice();
		const deviceSize = this.devices[device];
		const widthUnit = '';
		let width = this.parentWidth && this.parentWidth !== 0 ? this.parentWidth : deviceSize;

		// check option max width
		if (this.optionsMaxWidth) {
			width = this.getMaxWidth();
		}

		// width
		if (this.optionsWidth) {
			const getWidth = this.getWidth();
			width = getWidth.value;
		}

		return {
			value: parseInt(width),
			unit: widthUnit,
		};
	}

	getLink() {
		const isGif = this.path.includes('.gif');
		const imgSize = this.getVisualSize();
		const imagePath = this.path.replace(this.cdnPath, '');
		const link = !(this.path.includes(this.placeHoldPath)) && !isGif
			? `${this.compressPath}/${imgSize.value}/${imagePath}`
			: this.path;
		return link;
	}

	getWidthAttribute() {
		const defaultWidth = this.originalWidth && this.originalWidth !== 0 ? this.originalWidth : null;
		// let widthUnit = '';
		let width = 'auto';
		if (this.parentWidth && this.parentWidth !== 0) {
			if (defaultWidth && (defaultWidth < this.parentWidth)) {
				width = defaultWidth;
			} else if (!defaultWidth) {
				width = 'auto';
			}
		}

		// check image have maxwidth
		if (this.optionsMaxWidth && this.originalWidth) {
			width = this.getMaxWidth();
		}

		// check image have maxwidth
		if (this.optionsWidth && this.originalWidth) {
			const getWidth = this.getWidth();
			width = getWidth.value;
		}

		return width;
	}
}
export default ImageSize;
